import { useContext } from "react";
import { LayerContext } from "../LayerContext";
import { OsmRoadsInfo } from "../../../../types/LayerAdmin/OsmRoadsInfo";
import {
  TableColumn,
  TableDataType,
} from "../../../../types/Table/TableColumns";
import SortableTable from "../../../Table/SortableTable";
import { TableAction } from "../../../Table/TableAction";
import { Source } from "../../../../types/LayerAdmin/Source";
import { useOsmRoadsService } from "../../../../hooks";

interface ForceImportProps {
  backToImports: () => void;
  refreshImports: () => void;
}

const ForceImport = ({ backToImports, refreshImports }: ForceImportProps) => {
  const { layerInfo } = useContext(LayerContext)!;
  const osmInfo = layerInfo as OsmRoadsInfo;
  const osmRoadsService = useOsmRoadsService();

  const forceImport = async (source: Source) => {
    await osmRoadsService
      .Force(source.sourceId)
      .then((_) => {
        backToImports();
      })
      .catch(() => {});
  };

  const deferImport = async (source: Source) => {
    await osmRoadsService
      .Defer(source.sourceId)
      .then((_) => {
        refreshImports();
      })
      .catch(() => {});
  };

  const columns = [
    { displayName: "Source", field: "displayName", sortable: true },
    {
      displayName: "Est time.",
      field: "estTime",
      sortable: true,
    },
    {
      displayName: "Last import",
      field: "lastImport",
      dataType: TableDataType.DATE,
      dateFormat: "dd/MM/yyyy",
      sortable: true,
    },
    {
      displayName: "Last Deferred",
      field: "lastDeferred",
      dataType: TableDataType.DATE,
      dateFormat: "dd/MM/yyyy",
      sortable: true,
    },
    { displayName: "Time zone", field: "timeZone" },
  ] as TableColumn[];

  const actions = [
    { onClick: forceImport, show: true, content: "Queue" },
    { onClick: deferImport, show: true, content: "Defer" },
  ] as TableAction[];

  return (
    <SortableTable
      actions={actions}
      columns={columns}
      data={osmInfo.latestSources}
    />
  );
};

export default ForceImport;
